import React, {FC, useMemo} from 'react';
import styled from 'styled-components';

import {useAppSelector} from '../../../../../../../helpers/appReduxHelpers';
import {CommentModel} from '../../../../../../../models/api/commentModel';
import {TagCommentUnfurlModel} from '../../../../../../../models/api/commentUnfurlModel';
import {makeGetTag} from '../../../../../../../store/data/tags/tagsSelectors';
import {getUser} from '../../../../../../../store/data/teammates/teammatesSelectors';
import {ActivityTagPillContainer} from '../../../activityTagPill/activityTagPillContainer';
import {DefaultInlineUnfurlWrapper} from './commentDefaultInlineUnfurl';

/*
 * Props.
 */

interface CommentInlineTagUnfurlProps {
  comment: CommentModel;
  unfurl: TagCommentUnfurlModel;
}

/*
 * Styles.
 */

const StyledActivityTagPillContainer = styled(ActivityTagPillContainer)`
  vertical-align: middle;
`;

/*
 * Component.
 */

export const CommentInlineTagUnfurl: FC<CommentInlineTagUnfurlProps> = ({unfurl, comment}) => {
  const getTag = useMemo(() => makeGetTag(() => unfurl.tagId), [unfurl.tagId]);
  const tag = useAppSelector(getTag);
  const user = useAppSelector(getUser);

  if (!tag) {
    return <DefaultInlineUnfurlWrapper>{unfurl.token}</DefaultInlineUnfurlWrapper>;
  }

  return <StyledActivityTagPillContainer tag={tag} teammate={user} conversationId={comment.conversationId} />;
};
